import { rgba } from 'polished';

/**
 * Parses a shadow level to its CSS box shadow value based on the theme.
 *
 * @param theme - The theme object.
 * @param shadow - The level of shadow to apply.
 */ function parseShadow(theme, shadow) {
    const { size, blur, spread, opacity } = theme.shadows[shadow];
    return [
        `0px ${size}px ${blur}px ${spread}px ${rgba('black', opacity)}`,
        `0 ${shadow === 'none' ? '0 0' : '-1px 1px'} 0 ${rgba('black', 0.05)}`
    ].join(', ');
}

export { parseShadow };
//# sourceMappingURL=shadow.js.map
